var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticClass: "card-bind" },
      [
        _c("van-nav-bar", {
          attrs: { title: "更换信息", "left-text": "返回", "left-arrow": "" },
          on: { "click-left": _vm.onClickLeft }
        }),
        _vm._v(" "),
        _vm.mobile == _vm.data.mobile
          ? _c(
              "div",
              { staticClass: "page-content" },
              [
                _c("van-cell", {
                  attrs: { title: "原设备号", value: _vm.data.iccid }
                }),
                _vm._v(" "),
                _c("van-cell", {
                  attrs: {
                    title: "新设备码",
                    value: _vm.data.newiccid ? _vm.data.newiccid : "暂无"
                  }
                }),
                _vm._v(" "),
                _c("van-cell", {
                  attrs: { title: "收货信息" },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "label",
                        fn: function() {
                          return [
                            _vm._v(
                              "\n                    " +
                                _vm._s(_vm.data.name) +
                                " " +
                                _vm._s(_vm.data.mobile) +
                                " " +
                                _vm._s(_vm.data.city) +
                                " " +
                                _vm._s(_vm.data.address) +
                                "\n                "
                            )
                          ]
                        },
                        proxy: true
                      }
                    ],
                    null,
                    false,
                    3430420493
                  )
                }),
                _vm._v(" "),
                _c("van-cell", {
                  attrs: { title: "提交时间", value: _vm.data.addTime }
                }),
                _vm._v(" "),
                _c(
                  "van-cell",
                  { attrs: { title: "当前状态" } },
                  [
                    [
                      _vm.data.status == 0
                        ? _c("span", { staticStyle: { color: "#0086b3" } }, [
                            _vm._v("处理中")
                          ])
                        : _c("span", { staticStyle: { color: "#5daf34" } }, [
                            _vm._v("已发货")
                          ])
                    ]
                  ],
                  2
                ),
                _vm._v(" "),
                _vm.data.status == 1
                  ? _c(
                      "div",
                      [
                        _c("van-cell", {
                          attrs: { title: "快递单号" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "label",
                                fn: function() {
                                  return [
                                    _vm._v(
                                      "\n                        " +
                                        _vm._s(_vm.data.expressOrder) +
                                        " " +
                                        _vm._s(_vm.data.expressName) +
                                        "\n                    "
                                    )
                                  ]
                                },
                                proxy: true
                              }
                            ],
                            null,
                            false,
                            1621304498
                          )
                        }),
                        _vm._v(" "),
                        _c("van-cell", {
                          attrs: { title: "物流追踪" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "label",
                                fn: function() {
                                  return _vm._l(_vm.expressList, function(
                                    item
                                  ) {
                                    return _vm.expressList.length > 0
                                      ? _c(
                                          "div",
                                          { staticStyle: { margin: "10px 0" } },
                                          [
                                            _c("div", [
                                              _vm._v(_vm._s(item.time))
                                            ]),
                                            _vm._v(" "),
                                            _c("div", [
                                              _vm._v(
                                                _vm._s(item.context) +
                                                  "【" +
                                                  _vm._s(item.status) +
                                                  "】"
                                              )
                                            ])
                                          ]
                                        )
                                      : _c("div", [
                                          _vm._v(
                                            "\n                            暂时无物流信息，请稍后在查询\n                        "
                                          )
                                        ])
                                  })
                                },
                                proxy: true
                              }
                            ],
                            null,
                            false,
                            1199741291
                          )
                        })
                      ],
                      1
                    )
                  : _vm._e()
              ],
              1
            )
          : _c("div", [
              _c("div", { staticClass: "page-content" }, [
                _c("fieldset", { staticClass: "md-field" }, [
                  _c("div", { staticClass: "md-field-content" }, [
                    _c(
                      "div",
                      {
                        staticClass:
                          "md-field-item md-input-item is-solid is-browser left normal"
                      },
                      [
                        _c("div", { staticClass: "md-field-item-content" }, [
                          _c("label", { staticClass: "md-field-item-title" }),
                          _vm._v(" "),
                          _c("div", { staticClass: "md-field-item-control" }, [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.mobile,
                                  expression: "mobile"
                                }
                              ],
                              staticClass: "md-input-item-input",
                              attrs: {
                                max: "20",
                                name: "iccid",
                                placeholder: "请验证提交订单的手机号码",
                                maxlength: "",
                                autocomplete: "off",
                                type: "text"
                              },
                              domProps: { value: _vm.mobile },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.mobile = $event.target.value
                                }
                              }
                            })
                          ])
                        ])
                      ]
                    )
                  ])
                ])
              ])
            ])
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-79dc9f02", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-79dc9f02","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/changeInfo.vue
// module id = null
// module chunks = 